import React, { useState } from "react";
import { Link } from "react-router-dom";
import Logo from "../../../assets/logo.png"
import { useLocation, useNavigate } from "react-router-dom";
import LogOuticon from '../../../assets/logout.png'
import { useDispatch, useSelector } from 'react-redux';
import { userLogout } from '../../../redux/AuthSlice';
import { TbTags } from "react-icons/tb";
import { IoSettingsOutline } from "react-icons/io5";
import { ActiviDesIcon, ActivityIcon, AngleRightIcon, DashboardIcon, EditIcon, MessageTextIcon, NotificationBingIcon, SpecialBadgeIcon, WalletDesIcon, WalletIcon } from "../../../utils/icons";
const Sidebar = () => {
    const [isOpen, setIsOpen] = useState(false);
    const toggleSidebar = () => setIsOpen(!isOpen);
    const location = useLocation();
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const auth = useSelector((data) => data?.auth);

    const adminRoutes = [
        {
            title: 'Dashboard',
            link: '/dashboard',
            icon: DashboardIcon,
        },
        {
            title: 'Packing Lists',
            link: '/packing',
            icon: WalletIcon,
            children: [
                {
                    title: 'Tags',
                    link: '/tags',
                    icon: TbTags, // Replace with the actual settings icon
                },
                {
                    title: 'Packing Lists Settings',
                    link: '/packing/settings',
                    icon: IoSettingsOutline, // Replace with the actual settings icon
                },
            ],
        },
        {
            title: 'Itineraries',
            link: '/itineraries',
            icon: ActiviDesIcon,
        },
        {
            title: 'Destinations',
            link: '/destination',
            icon: WalletDesIcon,
        },
        {
            title: 'Traveller Profiles',
            link: '/traveller',
            icon: ActivityIcon,
            children: [
                {
                    title: 'Badges',
                    link: '/badges',
                    icon: SpecialBadgeIcon, // Replace with the actual settings icon
                },

            ],
        },
        {
            title: 'Tribe',
            link: '/tribe',
            icon: MessageTextIcon,
        },
        {
            title: 'Top Section',
            link: '/top-section',
            icon: MessageTextIcon,
        },
        // {
        //     title: 'Tags',
        //     link: '/tags',
        //     icon: TbTags,
        // },
        // {
        //     title: 'Edit Profile',
        //     link: '/edit-profile-user-admin',
        //     icon: EditIcon,
        // },
    ];
    const travellerRoutes = [
        // {
        //     title: 'Dashboard',
        //     link: '/travel-dashboard',
        //     icon: DashboardIcon,
        // },
        {
            title: 'Packing Lists',
            link: '/travel-packing',
            icon: WalletIcon,
        },
        {
            title: 'Edit Profile',
            link: '/edit-profile-user',
            icon: EditIcon,
        },
    ]
    const routes = auth?.isLoggedIn && auth?.userRole == 'ADMIN' ? adminRoutes : travellerRoutes

    const LogoutHandle = () => {
        dispatch(userLogout(null));
        navigate('/')
        // window.location.reload();
    }

    return (
        <>
            <div
                className={`fixed inset-y-0 h-screen overflow-auto left-0 transform w-64 ${isOpen ? "translate-x-0" : "-translate-x-full"
                    } md:translate-x-0 z-50 w-64 bg-aths p-5 text-dark font-quicksand font-bold flex flex-col transition-transform duration-300`}
            >
                <div className="flex flex-col gap-6 w-full h-full justify-between">
                    <div className="">
                        <Link to={`/`} >
                            <img src={Logo} className="w-full mt-6" alt="" />
                        </Link>

                        <p className=" mt-6 pb-2 font-quicksand font-medium text-black text-[12px] px-4" > Menu</p>
                        <ul className="flex-1 overflow-auto">
                            {routes?.map((item, index) => {
                                return (
                                    <li key={index} className="rounded-xl mb-2">
                                        {/* Main menu item */}
                                        <Link
                                            to={item?.link}
                                            className={`p-4 w-full block hover:bg-bgprimary ${item?.link == location?.pathname ? 'bg-bgprimary font-roboto-mono font-bold' : ''
                                                } rounded-2xl font-quicksand font-medium text-black text-[13px] hover:font-roboto-mono hover:font-bold transition-all duration-300`}
                                        >
                                            <span className="flex gap-3 items-center">
                                                {item?.icon && <item.icon size={20} />}
                                                <span>{item?.title}</span>
                                            </span>
                                        </Link>

                                        {/* Sub-menu items (if any) */}
                                        {item?.children && (
                                            <ul className="border-gray-300 pl-4">
                                                {item.children.map((subItem, subIndex) => (
                                                    <li key={subIndex} className="\">
                                                        <Link
                                                            to={subItem?.link}
                                                            className={`p-2 w-full block hover:bg-bgprimary ${subItem?.link == location?.pathname ? 'bg-bgprimary font-bold' : ''
                                                                } rounded-xl font-quicksand text-black text-[10px] transition-all duration-300`}
                                                        >
                                                            <span className="flex gap-3 items-center">
                                                                {subItem?.icon && <subItem.icon size={18} />}
                                                                <span>{subItem?.title}</span>
                                                            </span>
                                                        </Link>
                                                    </li>
                                                ))}
                                            </ul>
                                        )}
                                    </li>
                                );
                            })}
                        </ul>

                    </div>
                    <div className=" w-full bg-bgprimary rounded-xl">

                        <button onClick={LogoutHandle} className="flex items-center gap-4 rounded-lg  py-3 px-4 font-quicksand font-semibold text-[#10182B] text-[13px] uppercase " >
                            <img src={LogOuticon} alt="" />
                            Logout

                            {/* <AngleRightIcon /> */}

                        </button>
                    </div>
                </div>

                <button
                    onClick={toggleSidebar}
                    className="absolute top-2 right-2 md:hidden text-white"
                >
                    ✖
                </button>
            </div>

            {/* Hamburger Button */}
            {isOpen == false && (
                <button
                    onClick={toggleSidebar}
                    className="md:hidden fixed top-3 left-2 z-50 bg-bgprimary text-white w-[40px] h-[40px] p-2 rounded"
                >
                    ☰
                </button>
            )}


            {/* Overlay for Mobile */}
            {isOpen && (
                <div
                    onClick={toggleSidebar}
                    className="fixed inset-0 bg-black bg-opacity-50 z-40 md:hidden"
                ></div>
            )}
        </>

    );
};

export default Sidebar;
